import { io } from 'socket.io-client'
import { getEnv } from 'envConfig'
import { getAccessToken } from './keycloakService'

const normalizeEndpoint = (value = '') => String(value || '').trim().replace(/\/+$/, '')

class ChatSocketService {
  socket = null

  async connect() {
    if (this.socket) {
      if (!this.socket.connected) {
        this.socket.connect()
      }

      return this.socket
    }

    const accessToken = getAccessToken()
    const env = getEnv()
    const socketUrl = normalizeEndpoint(env.SOCKET_ENDPOINT || env.ENDPOINT || window.location.origin)

    this.socket = io(socketUrl, {
      transports: ['websocket', 'polling'],
      auth: { token: accessToken },
      autoConnect: true,
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 1000,
    })

    return this.socket
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect()
      this.socket = null
    }
  }

  emit(eventName, payload = {}) {
    if (!this.socket) {
      return
    }

    this.socket.emit(eventName, payload)
  }

  on(eventName, handler) {
    if (!this.socket) {
      return
    }

    this.socket.on(eventName, handler)
  }

  off(eventName, handler) {
    if (!this.socket) {
      return
    }

    this.socket.off(eventName, handler)
  }

  joinRoom(roomId) {
    this.emit('join_room', { roomId })
  }

  leaveRoom(roomId) {
    this.emit('leave_room', { roomId })
  }

  typingStart(roomId) {
    this.emit('typing_start', { roomId })
  }

  typingStop(roomId) {
    this.emit('typing_stop', { roomId })
  }
}

const chatSocketService = new ChatSocketService()
export default chatSocketService
